/**
 * FERP PDF Keyboard Shortcut Handler (DRR-079)
 *
 * Uses @mantine/hooks useHotkeys for PDF suite shortcuts.
 * Rendered as null — pure side-effect component.
 */

import { useHotkeys } from '@mantine/hooks';
import { usePdfSuite } from './PdfSuiteContext';

export function KeyboardShortcutHandler() {
  const { state, setCurrentPage, setScale, setAnnotationMode, undo, redo, toggleFullscreen } = usePdfSuite();
  const { viewer } = state;

  useHotkeys([
    // Navigation
    ['ArrowLeft', () => setCurrentPage(viewer.currentPage - 1)],
    ['ArrowRight', () => setCurrentPage(viewer.currentPage + 1)],
    ['Home', () => setCurrentPage(1)],
    ['End', () => setCurrentPage(viewer.numPages)],

    // Zoom
    ['mod+=', () => setScale(viewer.scale + 0.25)],
    ['mod+-', () => setScale(viewer.scale - 0.25)],
    ['mod+0', () => setScale(1.0)],

    // Fullscreen
    ['Escape', () => {
      if (state.isFullscreen) {
        toggleFullscreen();
      } else {
        setAnnotationMode(null);
      }
    }],
    ['F11', () => toggleFullscreen()],

    // Annotation tools
    ['h', () => setAnnotationMode(viewer.annotationMode === 'highlight' ? null : 'highlight')],
    ['t', () => setAnnotationMode(viewer.annotationMode === 'text' ? null : 'text')],
    ['d', () => setAnnotationMode(viewer.annotationMode === 'ink' ? null : 'ink')],
    ['s', () => setAnnotationMode(viewer.annotationMode === 'shape' ? null : 'shape')],
    ['n', () => setAnnotationMode(viewer.annotationMode === 'sticky' ? null : 'sticky')],

    // Undo/Redo
    ['mod+z', () => undo()],
    ['mod+shift+z', () => redo()],
  ]);

  return null;
}
